import { ListInterest } from '../api/httpHandlers'

interface Props {
  options: ListInterest[]
  interestDeviation: number
}

function formatInterestPeriod(noOfMonths: number) {
  if (noOfMonths === 3) return '3 mån'
  const years = noOfMonths / 12
  return `${years} år`
}

function MortgageOptions({ options, interestDeviation }: Readonly<Props>) {
  return (
    <>
      {options.length > 0
        ? options.map((value, index) => {
          const { interestRate, interestPeriod } = value
          const adjustedInterestRate = (
            +interestRate + interestDeviation
          ).toFixed(2)
          return (
            <option
              key={'select-' + index}
              value={index.toString()}
              data-option-value={interestRate}
            >
              {formatInterestPeriod(interestPeriod) +
                ' - ' +
                adjustedInterestRate.replace('.', ',') +
                '\u00A0%'}
            </option>
          )
        })
        : null}
    </>
  )
}

export default MortgageOptions
